/* Henne · Harley finder — port of henne-ymm (Cursor) extensions/ymm-finder/assets/harley-finder.js.
 * Options: static index asset (henne-ymm-index.json, built by tools/build_ymm_index.mjs).
 * Results: the bike collection rendered through the Section Rendering API (?section_id=henne-ymm-results).
 * Multiple instances per page; re-inits on shopify:section:load. */
(function () {
  if (window.HenneYmm) return;

  var STORAGE_KEY = "henne_ymm_bike";
  var indexCache = {};

  function loadIndex(url) {
    if (!indexCache[url]) {
      indexCache[url] = fetch(url, { credentials: "same-origin" })
        .then(function (r) {
          if (!r.ok) throw new Error("index " + r.status);
          return r.json();
        })
        .then(function (data) {
          if (!data || !data.y || !data.years) throw new Error("index format");
          return data;
        })
        .catch(function (e) {
          delete indexCache[url];
          throw e;
        });
    }
    return indexCache[url];
  }

  function readBike() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function saveBike(bike) {
    try {
      if (bike) window.localStorage.setItem(STORAGE_KEY, JSON.stringify(bike));
      else window.localStorage.removeItem(STORAGE_KEY);
    } catch (e) {}
  }

  function init(root) {
    if (!root || root.dataset.henneYmmReady) return;
    root.dataset.henneYmmReady = "1";

    var fields = {
      year: root.querySelector('[data-field="year"]'),
      family: root.querySelector('[data-field="family"]'),
      model: root.querySelector('[data-field="model"]'),
    };
    var form = root.querySelector("[data-form]");
    var submit = root.querySelector("[data-submit]");
    var clearBtn = root.querySelector("[data-clear]");
    var status = root.querySelector("[data-status]");
    var results = root.querySelector("[data-results]");
    var indexUrl = root.dataset.indexUrl;
    var sectionId = root.dataset.resultsSection || "henne-ymm-results";
    var limit = parseInt(root.dataset.limit, 10) || 8;
    var inline = root.dataset.inline !== "false";
    var rootUrl = (root.dataset.rootUrl || "/").replace(/\/?$/, "/");
    var index = null;
    var requestId = 0;

    // Missing markup (e.g. a customised copy of the section): leave the block inert instead of throwing.
    if (!fields.year || !fields.family || !fields.model || !form || !submit || !status || !results) return;

    // Placeholder text = the first <option> rendered by the section (so Liquid owns the wording).
    function placeholderOf(select, fallback) {
      var first = select.options && select.options[0];
      return first && first.value === "" && first.textContent.trim() ? first.textContent.trim() : fallback;
    }
    var placeholders = {
      year: placeholderOf(fields.year, "Select Year"),
      family: placeholderOf(fields.family, "Select Family"),
      model: placeholderOf(fields.model, "Select Model"),
    };

    // The status element is a live region that stays in the page; :empty CSS removes its spacing.
    function setStatus(text) {
      status.hidden = false;
      status.textContent = text || "";
    }

    function clearResults() {
      results.replaceChildren();
      results.hidden = true;
    }

    // Same as the Cursor widget's fill(), plus: auto-select when there is exactly one option.
    function fill(select, placeholder, values) {
      var current = select.value;
      select.replaceChildren();
      var empty = document.createElement("option");
      empty.value = "";
      empty.textContent = placeholder;
      select.append(empty);
      values.forEach(function (value) {
        var option = document.createElement("option");
        option.value = String(value);
        option.textContent = String(value);
        select.append(option);
      });
      var keep = values.some(function (v) { return String(v) === current; });
      select.value = keep ? current : values.length === 1 ? String(values[0]) : "";
      select.disabled = values.length === 0;
    }

    function yearData() {
      return index && fields.year.value ? index.y[fields.year.value] || null : null;
    }

    // Family = platform (Touring, Softail, Dyna, Sportster, V-Rod). Keep the index's platform order
    // (index.families) instead of sorting alphabetically; unknown families go last, A-Z.
    function families() {
      var y = yearData();
      if (!y) return [];
      var order = (index && index.families) || [];
      var rank = function (f) { var i = order.indexOf(f); return i === -1 ? order.length : i; };
      return Object.keys(y).sort(function (a, b) { return rank(a) - rank(b) || a.localeCompare(b); });
    }

    function models() {
      var y = yearData();
      return y && fields.family.value ? y[fields.family.value] || [] : [];
    }

    function selected() {
      var list = models();
      for (var i = 0; i < list.length; i++) if (list[i].m === fields.model.value) return list[i];
      return null;
    }

    function refresh() {
      fill(fields.year, placeholders.year, index.years);
      fill(fields.family, placeholders.family, fields.year.value ? families() : []);
      fill(fields.model, placeholders.model, fields.family.value ? models().map(function (e) { return e.m; }) : []);
      submit.disabled = !selected();
      if (clearBtn) clearBtn.hidden = !fields.year.value;
    }

    function collectionUrl(handle) {
      return rootUrl + "collections/" + encodeURIComponent(handle);
    }

    function bikeLabel(entry) {
      return fields.year.value + " " + entry.m;
    }

    function link(href, text, className) {
      var a = document.createElement("a");
      a.href = href;
      a.textContent = text;
      if (className) a.className = className;
      return a;
    }

    function partsText(count) {
      return count + (count === 1 ? " part" : " parts");
    }

    function search() {
      var entry = selected();
      if (!entry) {
        clearResults();
        setStatus("");
        return;
      }
      saveBike({ year: fields.year.value, family: fields.family.value, model: entry.m, handle: entry.h });
      var url = collectionUrl(entry.h);
      if (!inline) {
        window.location.href = url;
        return;
      }
      var id = ++requestId;
      setStatus("Searching…");
      root.setAttribute("aria-busy", "true");
      fetch(url + "?section_id=" + encodeURIComponent(sectionId), { credentials: "same-origin" })
        .then(function (r) {
          if (!r.ok) throw new Error("results " + r.status);
          return r.text();
        })
        .then(function (html) {
          if (id !== requestId) return;
          var doc = new DOMParser().parseFromString(html, "text/html");
          var data = doc.querySelector("[data-henne-ymm-results]");
          if (!data) throw new Error("results markup");
          var count = parseInt(data.getAttribute("data-count"), 10) || 0;
          var grid = data.querySelector("[data-product-container]");
          var items = grid ? Array.prototype.slice.call(grid.querySelectorAll(".m-product-item")) : [];
          results.replaceChildren();
          if (!count || !items.length) {
            results.hidden = true;
            setStatus("No parts for this motorcycle.");
            return;
          }
          items.slice(limit).forEach(function (el) { el.remove(); });
          setStatus(partsText(count));
          grid.classList.add("henne-ymm__grid");
          results.append(document.importNode(grid, true));
          var more = document.createElement("div");
          more.className = "henne-ymm__more";
          more.append(link(url, "See all " + partsText(count) + " for " + bikeLabel(entry), "m-button m-button--outline henne-ymm__all"));
          results.append(more);
          results.hidden = false;
        })
        .catch(function () {
          if (id !== requestId) return;
          results.replaceChildren();
          var p = document.createElement("p");
          p.className = "henne-ymm__fallback";
          p.append(link(url, "Open the parts list for " + bikeLabel(entry)));
          results.append(p);
          results.hidden = false;
          setStatus("Could not load parts.");
        })
        .then(function () {
          if (id === requestId) root.removeAttribute("aria-busy");
        });
    }

    function onChange(event) {
      var field = event.target && event.target.dataset ? event.target.dataset.field : null;
      if (!field || !index) return;
      if (field === "year") {
        fields.family.value = "";
        fields.model.value = "";
      } else if (field === "family") {
        fields.model.value = "";
      }
      requestId++;
      root.removeAttribute("aria-busy");
      refresh();
      // Like the Cursor widget: a complete selection searches right away (inline mode only).
      if (inline && selected()) search();
      else {
        clearResults();
        setStatus("");
      }
    }

    function reset() {
      requestId++;
      root.removeAttribute("aria-busy");
      fields.year.value = "";
      fields.family.value = "";
      fields.model.value = "";
      saveBike(null);
      clearResults();
      setStatus("");
      if (index) refresh();
      fields.year.focus();
    }

    form.addEventListener("change", onChange);
    form.addEventListener("submit", function (event) {
      event.preventDefault();
      if (selected()) search();
    });
    if (clearBtn) clearBtn.addEventListener("click", reset);

    loadIndex(indexUrl)
      .then(function (data) {
        index = data;
        // Pre-select the last bike (no automatic search on page load).
        var bike = readBike();
        if (bike && data.y[bike.year] && data.y[bike.year][bike.family]) {
          fill(fields.year, placeholders.year, data.years);
          fields.year.value = String(bike.year);
          fill(fields.family, placeholders.family, families());
          fields.family.value = bike.family;
          fill(fields.model, placeholders.model, models().map(function (e) { return e.m; }));
          fields.model.value = bike.model || "";
        }
        refresh();
      })
      .catch(function () {
        setStatus("Could not load motorcycles.");
      });
  }

  function initAll(scope) {
    var s = scope || document;
    if (s.matches && s.matches("[data-henne-ymm]")) init(s);
    s.querySelectorAll("[data-henne-ymm]").forEach(init);
  }

  window.HenneYmm = { init: init, initAll: initAll };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener("shopify:section:load", function (event) { initAll(event.target); });
})();
